<script setup lang="ts">
const {darkMode, extraWide} = storeToRefs(useCustomizerStore());
const {setDarkMode, setExtraWide} = useCustomizerStore();

const {authenticated} = useAuthentication()

const changeTheme = () => setDarkMode(!darkMode.value);
const changeExtraWide = () => setExtraWide(!extraWide.value);

withDefaults(defineProps<{ width?: number }>(), {width: 200})
</script>

<template>
  <v-navigation-drawer location="left" :rail="extraWide" elevation="1" :width="width" mobile-breakpoint="0">
    <perfect-scrollbar class="d-flex flex-column h-100" :options="{suppressScrollX: true}">
      <slot/>
    </perfect-scrollbar>

    <template v-slot:append>
      <div v-if="authenticated">
        <v-divider/>
        <div class="d-flex"
             :class="extraWide ? 'flex-column align-start px-1' : 'justify-center align-center'">
          <v-btn to="/" variant="text" color="primary" size="small" v-tooltip="`Go back to the start`">
            <HomeIcon stroke-width="1.5" size="20"/>
          </v-btn>
          <v-btn href="https://library.axoniq.io/axoniq-console-getting-started/main/index.html" variant="text"
                 color="primary" target="_blank" size="small" v-tooltip="`AxonIQ Docs`">
            <BookIcon stroke-width="1.5" size="20"/>
          </v-btn>
          <v-btn @click.prevent="changeTheme" variant="text" color="primary" size="small"
                 v-tooltip="`Toggle Dark mode`">
            <BulbFilledIcon stroke-width="1.5" size="20" v-if="!darkMode"/>
            <BulbIcon stroke-width="1.5" size="20" v-else/>
          </v-btn>

          <v-btn @click.prevent="changeExtraWide" variant="text" color="primary" size="small"
                 v-tooltip="`Toggle extra-wide mode`">
            <ArrowAutofitContentFilledIcon stroke-width="1.5" size="20" v-if="extraWide"/>
            <ArrowAutofitContentIcon stroke-width="1.5" size="20" v-else/>
          </v-btn>
        </div>

        <v-divider v-if="!extraWide"/>
      </div>

      <div class="d-flex flex-column gap-2 align-center mt-4 mb-2" v-if="!extraWide">
        <LegalLinkPopup/>

        <div class="text-center">
          <div class="text-subtitle-1 text-decoration-none">Copyright © 2025 AxonIQ BV.</div>
          <div class="text-subtitle-1 text-decoration-none">All Rights Reserved</div>
        </div>
      </div>

    </template>
  </v-navigation-drawer>
</template>
